import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=3d4c0d20&"
import script from "./Toolbar.vue?vue&type=script&lang=ts&"
export * from "./Toolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports